export enum ECloudManagement {
    MINDSHIELD = 'mindshield',
    CLIENT = 'client',
};

export enum EDataIdentifierTag {
    USER = 'user',
    GUEST = 'guest',
};

export enum EConversationMode {
    CHAT = 'chat',
    AUDIO = 'audio',
};

export enum EChatSource {
    PERSONA = 'persona',
    PLAYER = 'player',
};

export enum ERapportCollapsesConversationStatus {
    SUCCESS = 'success',
    STALEMATE = 'stalemate',
    FAILED = 'failed',
};